var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArched = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.33 59V30.32C35 29 39 21 48 21s13 8 13.67 9.32V59H34.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 22c8 0 11.87 6.9 12.67 8.55V58H35.33V30.55C36.14 28.89 40 22 48 22m0-2c-10.42 0-14.67 10.11-14.67 10.11v29.33c-.02.29.19.54.48.56h28.3c.29.02.54-.19.56-.48V30.11S58.42 20 48 20Z"
  })));
};
export default SvgArched;